import React, { useState } from "react";
import { Typography, makeStyles, Grid } from "@material-ui/core";
import { generateBuzzword } from "../utils/words";
import { currentTime } from "../utils/time";
import useKeyPress from "../hooks/useKeyPress";

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: "100vw",
    height: "100%",
    flexGrow: 1
  },
  characterWraper: {
    backgroundColor: "black",
    overflow: "hidden"
  },
  character: {
    whiteSpace: "pre",
    color: "white",
    fontSize: "40px",
    width: "100%"
  },
  characterCurrent: {
    backgroundColor: "gray"
  },
  blinkyCharacter: {
    backgroundColor: "gray",
    animation: `$blink 1s step-start 0s infinite`
  },
  characterOut: {
    color: "gray"
  },
  stats: {
    color: "white"
  },

  "@keyframes blink": {
    "50%": {
      backgroundColor: "black"
    }
  }
}));

const TypeTest = () => {
  const classes = useStyles();
  const initialWords = generateBuzzword();

  const [leftPadding, setLeftPadding] = useState(
    new Array(20).fill(" ").join("")
  );
  const [outgoingChars, setOutgoingChars] = useState("");
  const [currentChar, setCurrentChar] = useState(initialWords.charAt(0));
  const [incomingChars, setIncomingChars] = useState(initialWords.substr(1));

  const [startTime, setStartTime] = useState();
  const [wordCount, setWordCount] = useState(0);
  const [wpm, setWpm] = useState(0);

  const [accuracy, setAccuracy] = useState(0);
  const [typedChars, setTypedChars] = useState("");

  useKeyPress(key => {
    if (!startTime) {
      setStartTime(currentTime());
    }
    let updatedOutgoingChars = outgoingChars;
    let updatedIncomingChars = incomingChars;

    if (key === currentChar) {
      if (incomingChars.charAt(0) === " ") {
        setWordCount(wordCount + 1);
        const durationInMinutes = (currentTime() - startTime) / 60000.0;
        setWpm(((wordCount + 1) / durationInMinutes).toFixed(2));
      }
      if (leftPadding.length > 0) {
        setLeftPadding(leftPadding.substring(1));
      }
      updatedOutgoingChars += currentChar;
      setOutgoingChars(updatedOutgoingChars);

      setCurrentChar(incomingChars.charAt(0));

      updatedIncomingChars = incomingChars.substring(1);
      if (updatedIncomingChars.split(" ").length < 10) {
        updatedIncomingChars += " " + generateBuzzword();
      }
      setIncomingChars(updatedIncomingChars);
    }
    const updatedTypedChars = typedChars + key;
    setTypedChars(updatedTypedChars);
    setAccuracy(
      ((updatedOutgoingChars.length * 100) / updatedTypedChars.length).toFixed(
        2
      )
    );
  });

  return (
    <Grid
      container
      direction="column"
      justify="space-between"
      className={classes.wrapper}
    >
      <Grid item align="center">
        <div className={classes.characterWraper}>
          <Typography variant="subtitle1" className={classes.character}>
            <span className={classes.characterOut}>
              {(leftPadding + outgoingChars).slice(-20)}
            </span>
            <span
              className={`${
                typedChars.length >= 1
                  ? classes.characterCurrent
                  : classes.blinkyCharacter
              }`}
            >
              {currentChar}
            </span>
            <span>{incomingChars.substr(0, 20)}</span>
          </Typography>
        </div>
      </Grid>

      <Grid item align="end">
        <Typography variant="h6" className={classes.stats}>
          WPM: {wpm} | ACC: {accuracy}%
        </Typography>
      </Grid>
    </Grid>
  );
};

export default TypeTest;
